import { useRef, useState } from 'react'
import type { CenterCanvasConfig } from '../types/center-canvas-config'

/**
 * The canvas's effective scale (resolved from `zoom`, including fit-to-spread), plus
 * latest-value mirrors of `zoom`, the scale and `onZoomChange` for listeners and callbacks that
 * must not re-subscribe on every zoom step. The mirrors are reassigned on every render.
 */
export function useCanvasScale({
  zoom,
  onZoomChange,
}: {
  zoom: number
  onZoomChange: CenterCanvasConfig['onZoomChange']
}) {
  // const BORDER_PX = 2

  const [scale, setScale] = useState<number>(1)
  const zoomRef = useRef(zoom)
  const scaleRef = useRef(scale)
  const onZoomChangeRef = useRef(onZoomChange)

  zoomRef.current = zoom
  scaleRef.current = scale
  onZoomChangeRef.current = onZoomChange

  return { scale, setScale, zoomRef, scaleRef, onZoomChangeRef }
}
